export default "__VITE_ASSET__BPQkF9tc__"